const helperLightbox = function (app) {
    const $document = $(document);
    const dataAttr = "data-js-lightbox";
    const selector = `[${dataAttr}]`;

    const init = function () {
        if (!app.lightboxReady) {
            app.lightboxReady = true;
            registerEvents();
        }
    };

    const registerEvents = function () {
        $document.on("click", selector, function (ev) {
            ev.preventDefault();
            const $elt = $(ev.target).closest(selector);
            const lightboxParams = $elt.attr("data-js-lightbox-params");
            const event = new CustomEvent("GeLightbox", {
                cancelable: false,
                bubbles: false,
                detail: {
                    type: "onOpen",
                    params: {
                        options: JSON.parse(lightboxParams),
                    },
                },
            });

            window.dispatchEvent(event);
        });
    };

    return {
        init: init(),
    };
};

export default helperLightbox;
